import { usePermissions } from '../core/PermissionContext';

export function usePageAccess(page: string): boolean {
  const engine = usePermissions();
  return engine.hasPageAccess(page);
}

export function useAccessiblePages(): string[] {
  const engine = usePermissions();
  return engine.getPages();
}
